import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';

@Component({
  templateUrl: './sso.page.html'
})
export class SsoPage implements OnDestroy {
  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;


  ssoprovider: any = { authenticationSchemas: [], ssoProvider: { name: null, displayName: "Settings.ApplicationGeneralSettingsSection.NoSSO" } };
  ssoRequired: boolean = false;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationId) return;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Security(this.selectedOrganisationId), BreadCrumbOptions.Security_Sso(this.selectedOrganisationId));

      this.getSsoSettings();
    });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getSsoSettings() {
    this.settingsService.getSsorequired(this.selectedOrganisationId).subscribe({
      next: (sso: any) => {
        this.ssoRequired = sso.ssoRequired;
      }
    });
    (await this.settingsService.getSsoprovider(this.selectedOrganisationId)).subscribe({
      next: (ssoProv: any) => {
        if (ssoProv == undefined) return;
        this.ssoprovider.authenticationSchemas = ssoProv.authenticationSchemas;
        if (ssoProv.ssoProvider != "" && this.ssoprovider.authenticationSchemas.findIndex((p: any) => p.name == ssoProv.ssoProvider) > -1)
          this.ssoprovider.ssoProvider = this.ssoprovider.authenticationSchemas[this.ssoprovider.authenticationSchemas.findIndex((p: any) => p.name == ssoProv.ssoProvider)];
      }
    });
  }

  updateSsoProvider(value: string) {
    this.ssoprovider.ssoProvider = this.ssoprovider.authenticationSchemas[this.ssoprovider.authenticationSchemas.findIndex((p: any) => p.name == value)];
    this.settingsService.updateGeneralSettings({ key: "ssoProvider", body: this.ssoprovider.ssoProvider }, this.selectedOrganisationId);
  }

  resetSsoProvider() {
    this.settingsService.updateGeneralSettings({ key: "ssoProvider", body: "" }, this.selectedOrganisationId);
  }

  async updateSsoRequired(key: string, event: any) {
    this.ssoRequired = (event.target as HTMLInputElement).checked;
    this.settingsService.updateGeneralSettings({ key: "ssoRequired", body: this.ssoRequired }, this.selectedOrganisationId);
    if (this.ssoRequired) {
      this.updateSsoProvider('AzureAD');
    } else {
      this.resetSsoProvider();
    }
  }
}
